const originalFetch = window.fetch;

window.fetch = function (...args) {
  const url = args[0];
  const isCartEndpoint = typeof url === 'string' &&
    ['/cart/add.js', '/cart/update.js', '/cart/change.js'].some(path => url.includes(path));

  if (isCartEndpoint) {
    const stack = new Error().stack || '';
    const isFromConsole = stack.includes('at <anonymous>') || stack.includes('VM');
    if (isFromConsole) {
      return Promise.reject('Blocked');
    }
  }
  return originalFetch.apply(this, args);
};

if (window.location.pathname === "/cart") {
  window.location.replace("/?cart=true");
}

// Open cart drawer if URL has ?cart=true
document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);
  if (params.get("cart") === "true") {
    const cartDrawer = document.querySelector("cart-drawer");
    const overlay = document.getElementById("cartx-drawer-overlay");

    if (cartDrawer && overlay) {
      cartDrawer.classList.add("drawer-open");
      overlay.classList.add("open-overlay");
    }

    document.body.classList.add("cartx-open");
  }
});

let freeGiftPrice = 100;
let priceArray= [0,1];
let currentDiscountCodes = [];
var user_cart = null;
let isProcessing = false;
let showConfetti = false;
const shopifyStorefrontApiUrl =
  "https://indigoworkwear.myshopify.com/api/2025-01/graphql.json";
const shopifyStorefrontToken = "971e4c8bfbcab81db79a82e5b8510e2c";
if (window.location.pathname !== "/cart") {
  fetchCart();
}

function fetchCart() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      user_cart = cart;
      cartx();
    })
    .catch((error) => console.error("Error fetching cart:", error));
}

function bindingEvent() {
  document
    .querySelectorAll(".cartx-drawer-product-quantity-button")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        const eventName = button.getAttribute("name");

        if (eventName !== "plus" && eventName !== "minus") return;

        const li = event.target.closest("li");
        if (!li) return;

        const variantId = li.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [variantId]: {
            quantity: parseInt(li.getAttribute("data-quantity")) || 0,
            price: parseInt(li.getAttribute("data-price")) || 0,
            type: li.getAttribute("data-product-type") || "",
          },
        };

        switch (eventName) {
          case "plus":
            cartx(variantObject, "ADD");
            break;
          case "minus":
            cartx(variantObject, "REMOVE");
            break;
        }
      });
    });

  // Simple BOGO Bundle Multi-Add Event Listener
  document
  .querySelectorAll('.cartx-bogo-offer-add-to-cart')
  .forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      
      // Find the parent container and collect all variants
      const upsellContainer = this.closest('.cartx-bogo-offer-wrap')?.querySelector('.cartx-upsell-product-list')
      
      const variantObject = {};

      
      if (upsellContainer) {
        const productItems = upsellContainer.querySelectorAll('.cartx-upsell-product-item');
        
        productItems.forEach(item => {
          const buttonWrap = item.querySelector('.cartx-product-button-wrap');
          
          if (buttonWrap) {
            const variantId = buttonWrap.getAttribute('data-variant-id');
            const price = buttonWrap.getAttribute('data-price');
            const productType = buttonWrap.getAttribute('data-product-type');
            const quantity = buttonWrap.getAttribute('data-quantity');
            
            if (variantId && price) {
              variantObject[variantId] = {
                quantity: parseInt(quantity) || 1,
                price: parseInt(price) || 0,
                type: productType || "",
              };
            }
          }
        });
      }
      
      // Call cartx function with MULTI_ADD event
      if (Object.keys(variantObject).length > 0) {
        cartx(variantObject, "MULTI_ADD");
      }
    });
  });

  const ribbons = document.querySelectorAll(".cartx-announcement-ribbon");

  ribbons.forEach(ribbon => {
    const leftBtn = ribbon.querySelector(".scroll-btn.left");
    const rightBtn = ribbon.querySelector(".scroll-btn.right");

    const scrollableItems = ribbon.querySelectorAll(".cartx-announcement-ribbon-text");

    leftBtn.addEventListener("click", () => {
      ribbon.scrollBy({ left: -200, behavior: "smooth" });
    });

    rightBtn.addEventListener("click", () => {
      ribbon.scrollBy({ left: 200, behavior: "smooth" });
    });
  });

  document
    .querySelectorAll(".cartx-free-claim-buttton.cartx-claim-add-to-cart")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        const variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [variantId]: {
            quantity: 1,
            claimed_gift: "true",
          },
        };

        cartx(variantObject, "CLAIM_ADD");
      });
    });

  document
    .querySelectorAll(".cartx-free-claim-buttton.cartx-claim-remove-from-cart")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        const variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [variantId]: {
            quantity: 1,
            claimed_gift: "true",
          },
        };

        cartx(variantObject, "CLAIM_REMOVE");
      });
    });

  document.querySelectorAll(".code-copy-btn").forEach(function (button) {
    button.addEventListener("click", function () {
      const valueToCopy = this.getAttribute("data-code");

      if (valueToCopy) {
        // Copy to clipboard
        const tempInput = document.createElement("input");
        document.body.appendChild(tempInput);
        tempInput.value = valueToCopy;
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);

        // Show popup message with animation
        const popup = document.createElement("div");
        popup.className = "copy-popup";
        popup.textContent = "Copied successfully!";
        document.body.appendChild(popup);

        popup.style.position = "fixed";
        popup.style.bottom = "-50px";
        popup.style.left = "50%";
        popup.style.transform = "translateX(-50%)";
        popup.style.opacity = 0;
        popup.style.transition = "all 0.3s ease";

        // Force reflow to apply transition
        void popup.offsetHeight;

        // Animate in
        popup.style.bottom = "70px";
        popup.style.opacity = 1;
        setTimeout(function () {
          popup.style.transition = "all 0.3s ease";
          popup.style.bottom = "0px";
          popup.style.opacity = "0";

          setTimeout(function () {
            popup.remove();
          }, 300);
        }, 1000);
      }
    });
  });

  document.querySelectorAll(".cartx-empty-upsell").forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const variantId = button.getAttribute("data-variant-id");
      if (!variantId) return;

      const variantObject = {
        [variantId]: {
          quantity: parseInt(button.getAttribute("data-quantity")) || 0,
          price: parseInt(button.getAttribute("data-price")) || 0,
          type: button.getAttribute("data-product-type") || "",
        },
      };

      cartx(variantObject, "ADD");
    });
  });

  document.querySelectorAll(".prv-submit-button").forEach((button) => {
    button.addEventListener("click", function () {
      const input = this.closest(".prv-coupon-input-container").querySelector(
        ".prv-coupon-input"
      );
      applyCode(input);
    });
  });

  document.querySelectorAll(".prv-coupon-input").forEach((input) => {
    input.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        applyCode(input);
      }
    });
  });

  if (document.getElementById("cartx-remove-btn") !== null) {
    document
      .getElementById("cartx-remove-btn")
      .addEventListener("click", function () {
        const code = this.getAttribute("data-discount-code");

        removeDiscount(user_cart?.token, code);
      });
  }

  const slider = document.getElementById("cartx-claim-product-list");
  const progress = document.getElementById("scrollProgress");

  if (slider && progress) {
    slider.addEventListener("scroll", () => {
      const scrollLeft = slider.scrollLeft;
      const scrollWidth = slider.scrollWidth - slider.clientWidth;
      const scrolledPercent = (scrollLeft / scrollWidth) * 100;
      progress.style.width = `${scrolledPercent}%`;
    });
  }

  document
    .querySelectorAll(".cartx-variant-cart")
    .forEach(function (selector) {
      
      selector.addEventListener("change", function (event) {
        const selectedOption = event.target.selectedOptions[0];
        const selectedVariantId = selectedOption.value;
        const variantPrice = selectedOption.getAttribute("data-price");
        const quantity = selectedOption.getAttribute("data-quantity");
        const type = selectedOption.getAttribute("data-product-type");
        const finalPrice = selectedOption.getAttribute("data-final-price");

        const li = event.target.closest("li");
        if (!li) return;

        const variantId = li.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [selectedVariantId]: {
            quantity: Number(quantity),
            replace_variant: variantId,
            price: variantPrice,
            type:type,
            final_price:finalPrice
          },
        };

        cartx(variantObject, "ADD");
      });
    });

    document.querySelectorAll(".cartx-variant-upsell").forEach(function (selector) {
      // Remove the previous event listener, if any
      selector.removeEventListener("change", handleVariantChange);
    
      // Add the new event listener
      selector.addEventListener("change", handleVariantChange);
    });

  const viewAllBtn = document.querySelector(".prv-view-all");
  const closeBtn = document.querySelector(".cartx-offer-close");
  const offerPanel = document.querySelector(".cartx-all-offers");

  if (viewAllBtn && offerPanel) {
    viewAllBtn.addEventListener("click", function () {
      offerPanel.classList.add("is--visible");
    });
  }

  if (closeBtn && offerPanel) {
    closeBtn.addEventListener("click", function () {
      offerPanel.classList.remove("is--visible");
    });
  }

  const signinBtn = document.getElementById("cartx-signin-btn");
  if (signinBtn) {
    signinBtn.addEventListener("click", function (event) {
      event.preventDefault();
      window.location.href = "/account";
    });
  }

  const applyButtons = document.querySelectorAll(".cartx-apply-button-wrapper");
  if (applyButtons.length > 0) {
    applyButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        const couponCode = this.getAttribute("data-code");
        applyDiscount(user_cart?.token, couponCode);
      });
    });
  }

  const removeButtons = document.querySelectorAll(
    ".cartx-remove-button-wrapper"
  );
  if (removeButtons.length > 0) {
    removeButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        const couponCode = this.getAttribute("data-code");
        removeDiscount(user_cart?.token, couponCode);
      });
    });
  }

  document.querySelectorAll('.shipping-info-toggle').forEach(function (toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      const infoBox = document.querySelector('.shipping-info-content');
      infoBox.classList.toggle('open');
      toggleBtn.setAttribute('aria-expanded', infoBox.classList.contains('open'));
    });
  });

  const cartxNoteTextarea = document.getElementById("CartxSpecialInstructions");
  const cartxNoteInputGroup = cartxNoteTextarea?.closest(".input-group");

  function toggleCheckIcon() {
    if (cartxNoteTextarea?.value.trim().length > 0) {
      cartxNoteInputGroup.classList.add("filled");
    } else {
      cartxNoteInputGroup.classList.remove("filled");
    }
  }

  if (cartxNoteTextarea){
  toggleCheckIcon();
  }

  cartxNoteTextarea?.addEventListener('change', function () {
    toggleCheckIcon();
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        note: this.value
      })
    });
  });

  // for Apparel products Protect ----- start
  document.getElementById('apparelToggle')?.addEventListener('change', function () {
    if (this.checked) {
      apparelProtectorAdd();
    } else {
      apparelProtectorRemove();
    }
  });

  function apparelProtectorAdd(variantID, event) {
      
    const wrapper = document.querySelector("#apparelProtectorVariantSelect");
    const selectedOption = wrapper.options[wrapper.selectedIndex];
    const variantId = wrapper.value;
    if (!variantId) return;

    const variantObject = {
      [variantId]: {
        quantity: 1,
        price: parseInt(selectedOption.getAttribute("data-price")) || 0,
        type: "",
      },
    };

    cartx(variantObject, "ADD");
  }

  function apparelProtectorRemove(event) {
    const wrapper = document.querySelector("#apparelProtectorVariantSelect");
    const selectedOption = wrapper.options[wrapper.selectedIndex];
    const variantId = wrapper.value;
    if (!variantId) return;

    const variantObject = {
      [variantId]: {
        quantity: 1,
        price: parseInt(selectedOption.getAttribute("data-price")) || 0,
        type: "",
      },
    };

    cartx(variantObject, "REMOVE");
  }

  const protectorVariantSelect = document.getElementById('protectorVariantSelect');

  protectorVariantSelect?.addEventListener('change', function () {
    const selectedValue = this.value;
    const selectedOption = this.options[this.selectedIndex];
    const selectedPrice = selectedOption.dataset.price;
    if(selectedValue != 0){
      protectorVariantSelect.setAttribute("data-variant-id", selectedValue);
      protectorVariantSelect.setAttribute("data-price", selectedPrice);
      protectorAddToCartClick();
    }else{
      protectorRemoveFromCartClick();
    }
  });
  // for Footwear Fit Protect ----- end

  const checkoutBtn = document.querySelector(".cartx-checkout-button");
  const policyCheckbox = document.querySelector("#agreePolicy");
  const policyText = document.querySelector(".policy-text");
  const policyLinks = policyText?.querySelectorAll("a");
  const policyCheckboxBox = document.querySelector(".custom-checkbox");
  const drawerInner = document.querySelector(".cartx-drawer-body-wrap");

  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      e.preventDefault();

      if (!policyCheckbox.checked) {
        // Scroll to the bottom of the drawer
        if (drawerInner) {
          drawerInner.scrollTo({
            top: drawerInner.scrollHeight,
            behavior: "smooth"
          });
        }

        // Highlight checkbox border and text in red
        policyCheckboxBox.style.border = "2px solid red";
        policyText.style.color = "red";
        policyLinks?.forEach(link => link.style.color = "red");

        // Remove highlight after 2 seconds
        setTimeout(() => {
          policyCheckboxBox.style.border = "";
          policyText.style.color = "";
          policyLinks?.forEach(link => link.style.color = "");
        }, 2000);
      } else {
        // Redirect to checkout
        window.location.href = "/checkout";
      }
    });
  }

  initPincodeInput();
  
  loadedEvents();
}

function handleVariantChange(event) {
  
  const selectedOption = event.target.selectedOptions[0];
  const selectedVariantId = selectedOption.value;
  const variantPrice = selectedOption.getAttribute("data-price");
  const type = selectedOption.getAttribute("data-product-type");
  const image = selectedOption.getAttribute("data-image");

  const li = event.target.closest(".cartx-upsell-product-item").querySelector('.cartx-product-button-wrap');
  if (!li) return;

  const formattedPrice = `₹ ${(parseInt(variantPrice) / 100).toFixed(2)}`;

  li.closest('.cartx-upsell-product-item').querySelector('.cartx-upsell-item-img').src = image;
  li.closest('.cartx-upsell-product-item').querySelector('.cartx-upsell-item-price .current-price').innerHTML = formattedPrice;
  li.setAttribute("data-variant-id", selectedVariantId);
  li.setAttribute("data-price", variantPrice);
  li.setAttribute("data-product-type", type);
}


function isValidIndianPincodeCart(pincode) {
  var pincodeInput = document.getElementById("pincode_input_cart");
  var expectedCart = document.querySelector(".cartx-drawer .expected_cart");
  pincodeInput.style.color = "#f00";
  expectedCart.textContent = "Enter a valid pincode";
  expectedCart.style.color = "#f00";
  // pincodeInput.style.borderColor = "#f00";
  document.querySelector(".cartx-verified-cart-svg").classList.remove('show-svg');
  // document.getElementById("verified_cart").style.display = "none";
  var regex = /^[1-9][0-9]{5}$/;
  return regex.test(pincode);
}

function getFormattedDate(date) {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString("en-IN", options);
}

function handlePincodeInputChangeCart() {
  var pincode = document.getElementById("pincode_input_cart").value;
  if (isValidIndianPincodeCart(pincode)) {
    localStorage.setItem("validPin", pincode);
    document.getElementById("pincode_input_cart").style.color = "green";
    // document.getElementById("pincode_input_cart").style.borderColor = "black";
    // document.getElementById("verified_cart").style.display = "block";

    var url = "https://neworder.plumgoodness.com/get-estimate-date";
    var data = JSON.stringify({ drop_pincode: pincode });

    var xhr = new XMLHttpRequest();
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var result = JSON.parse(xhr.responseText);
        var expectedCart = document.querySelector(".cartx-drawer .expected_cart");

        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + parseInt(result.expects_max_date));
        // Adding 12 hours to the current time
        currentDate.setHours(currentDate.getHours());
        currentDate.setDate(currentDate.getDate() + 1);

        const formattedDate = getFormattedDate(currentDate);
        expectedCart.innerHTML = `Estimated Delivery Date <br> ${formattedDate}`;
        expectedCart.style.color = "green";
        document.querySelector(".cartx-verified-cart-svg").classList.add('show-svg');
      }
    };
    xhr.send(data);
  }
}

function getFormattedDate(date) {
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const weekday = date.toLocaleString('default', { weekday: 'long' });

  return `${day}${this.getDaySuffix(day)} ${month}, ${weekday}`;
}

function getDaySuffix(day) {
  if (day >= 11 && day <= 13) {
      return 'th';
  }
  switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
  }
}

function initPincodeInput() {
  const inputField = document.getElementById("pincode_input_cart");
  if (!inputField) return;

  const storedPin = localStorage.getItem("validPin");
  if (storedPin) {
    inputField.value = storedPin;
    handlePincodeInputChangeCart(); // run immediately
  }

  inputField.addEventListener("keyup", handlePincodeInputChangeCart);
}

function startLoader() {
  const cartLoader = document.querySelector(".cartx-atc-cart-loading");
  if (cartLoader) {
    cartLoader.classList.add("loading");
  }
}

function stopLoader() {
  const cartLoader = document.querySelector(".cartx-atc-cart-loading");
  if (cartLoader) {
    cartLoader.classList.remove("loading");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // const recommendationsEl = document.querySelector("product-recommendations");

  // if (recommendationsEl) {
  //   const observer = new MutationObserver(() => {
  //     if (
  //       recommendationsEl.classList.contains("product-recommendations--loaded")
  //     ) {
  //       loadedEvents();

  //       observer.disconnect(); // stop observing once it's loaded
  //     }
  //   });

  //   observer.observe(recommendationsEl, { attributes: true });
  // }

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList.contains("cartx-product-button-wrap")) {

          loadedEvents();
        }
      });
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  
  
  loadedEvents();
});

function handleAddToCartClick(event) {
  const button = event.currentTarget;
    
  const wrapper = button.closest(".cartx-product-button-wrap");
  const variantId = wrapper.getAttribute("data-variant-id");
  if (!variantId) return;

  wrapper.classList.add("cartx-button-loadding");

  const variantObject = {
    [variantId]: {
      quantity: parseInt(wrapper.getAttribute("data-quantity")) || 0,
      price: parseInt(wrapper.getAttribute("data-price")) || 0,
      type: wrapper.getAttribute("data-product-type") || "",
    },
  };

  cartx(variantObject, "ADD");
}

function protectorAddToCartClick(variantID, event) {
    
  const wrapper = document.querySelector("#protectorVariantSelect");
  const variantId = wrapper.getAttribute("data-variant-id");
  if (!variantId) return;

  const variantObject = {
    [variantId]: {
      quantity: parseInt(wrapper.getAttribute("data-quantity")) || 0,
      price: parseInt(wrapper.getAttribute("data-price")) || 0,
      type: wrapper.getAttribute("data-product-type") || "",
    },
  };

  cartx(variantObject, "ADD");
}

function protectorRemoveFromCartClick(event) {
  const wrapper = document.querySelector("#protectorVariantSelect");
  const variantId = wrapper.getAttribute("data-variant-id");
  if (!variantId) return;

  const variantObject = {
    [variantId]: {
      quantity: 0,
      price: parseInt(wrapper.getAttribute("data-price")) || 0,
      type: wrapper.getAttribute("data-product-type") || "",
    },
  };

  cartx(variantObject, "REMOVE PROTECTOR");
}

function handleRemoveFromCartClick(event) {
  const button = event.currentTarget;

  const wrapper = button.closest(".cartx-product-button-wrap");
  const variantId = wrapper.getAttribute("data-variant-id");
  if (!variantId) return;

  wrapper.classList.add("cartx-button-loadding");

  const variantObject = {
    [variantId]: {
      quantity: parseInt(wrapper.getAttribute("data-quantity")) || 0,
      price: parseInt(wrapper.getAttribute("data-price")) || 0,
      type: wrapper.getAttribute("data-product-type") || "",
    },
  };

  cartx(variantObject, "REMOVE");
}

function loadedEvents() {
    
    
    

    
  
  document.addEventListener("click", function (e) {
  const button = e.target.closest(".cartx-add-to-cart:not(.plus):not(.cartx-sold-out)");
  if (button) {
    // button.removeEventListener("click", handleAddToCartClick);
      // button.addEventListener("click", handleAddToCartClick);
    handleAddToCartClick({ 
      currentTarget: button
    });
  }
});

  document.querySelectorAll(".cartx-add-to-cart.plus").forEach((button) => {
    
    button.removeEventListener("click", handleAddToCartClick);
    button.addEventListener("click", handleAddToCartClick);
  });

  document
    .querySelectorAll(".cartx-remove-from-cart.minus")
    .forEach((button) => {
      
      button.removeEventListener("click", handleRemoveFromCartClick);
      button.addEventListener("click", handleRemoveFromCartClick);
    });

    document
    .querySelectorAll(".cartx-icon")
    .forEach((button) => {
      
      button.removeEventListener("click", openDrawer);
      button.addEventListener("click", openDrawer);
    });

    document.querySelectorAll(".cartx-variant-upsell").forEach(function (selector) {
      // Remove the previous event listener, if any
      selector.removeEventListener("change", handleVariantChange);
    
      // Add the new event listener
      selector.addEventListener("change", handleVariantChange);
    });

    document.querySelectorAll('.cartx-variant-switcher').forEach(function (selector) {
      selector.removeEventListener("click", handleVariantChangeQuantity);
      selector.addEventListener("click", handleVariantChangeQuantity);
    })


}

function handleVariantChangeQuantity(event) {
  
  
  const variantId = event.target.getAttribute("data-variant-id");
  const productId = event.target.getAttribute("data-product-id");
  const price = event.target.getAttribute("data-variant-price");
  

  document.querySelectorAll('.cartx-product-button-wrap[data-product-id="' + productId + '"]').forEach(function (selector) {
    selector.setAttribute("data-variant-id", variantId);
    selector.setAttribute("data-price", price);
    
  });

  let quantity = 0;

  if (user_cart?.items) {
    const cartItem = user_cart.items.find(item => item.variant_id == variantId);
    quantity = cartItem ? cartItem.quantity : 0;
  }

  updateQuantity({ [variantId]: { quantity } }, 'CHANGE');
}

function openDrawer(event) {
  event.preventDefault();
  const cartDrawer = document.querySelector("cart-drawer");
  const overlay = document.querySelector(".cartx-drawer-overlay");
  if (cartDrawer && overlay) {
    cartDrawer.classList.add("drawer-open");
    overlay.classList.add("open-overlay");
  }
  document.body.classList.add("cartx-open");
  
  // Add click handler to window
  setTimeout(() => {
    window.onclick = function(event) {
      const cartDrawer = document.querySelector("cart-drawer");
      
      if (cartDrawer && cartDrawer.classList.contains("drawer-open")) {
        // Check if clicked on overlay or cart-drawer but not on inner content
        if (event.target.id === "cartx-drawer-overlay" || 
            (event.target.tagName === "CART-DRAWER" && event.target === cartDrawer)) {
          closeDrawer();
        }
      }
    };
  }, 100);
}

function closeDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  const overlay = document.querySelector(".cartx-drawer-overlay");
  if (cartDrawer && overlay) {
    cartDrawer.classList.remove("drawer-open");
    overlay.classList.remove("open-overlay");
  }

  document.body.classList.remove("cartx-open");
  window.onclick = null;
}

function cartx(variantObject = {}, event) {
  console.log('dkdkdkdkd function start time ------ start', new Date().toLocaleTimeString());
  if (isProcessing) {
    updateQuantity(variantObject, null);
    return;
  }

  var footwearProtectId = document.querySelector("cart-drawer #protectorVariantSelect")?.getAttribute("data-variant-id");
  let totalFootwearQty = 0;
  let totalApparelPrice = 0;


  isProcessing = true;
  startLoader();

  const allProducts = {};

  const filteredObjects = JSON.parse(document.body.getAttribute("metaobject"));
  const cartFreebie = cleanData(
    JSON.parse(document.body.getAttribute("cartfreebie"))
  );

  

  let claimGift = JSON.parse(document.body.getAttribute("claimgift"));
  let claimGiftLimit = 1;
  if (claimGift) {
  let claimGiftLimit = claimGift[0]?.gift_limit || 1;
  }

  

  let localStorageClaimGift = JSON.parse(
    localStorage.getItem("claimedGiftProducts")
  ) || {};

  

  const cartUpdatedObject = {};
  let totalFreeProduct = 0;
  let totalFreeProductPrice = 0;
  let totalCombosQuantity = 0;
  let totalCombosPrice = 0;

  let isClaimedGift = false;

  user_cart?.items.forEach(
    ({
      id,
      quantity,
      final_line_price,
      original_line_price,
      product_type,
      properties,
    }) => {
      const productId = id.toString();

      allProducts[productId] = Number(allProducts[productId] || 0) + quantity;

      if (!cartUpdatedObject[productId])
        cartUpdatedObject[productId] = quantity;

      if (
        (final_line_price === freeGiftPrice && original_line_price === freeGiftPrice) ||
        (final_line_price === 0 && original_line_price === 0)
      ) {
        totalFreeProduct++;
        totalFreeProductPrice += final_line_price;
        if (properties?.claimed_gift !== "true") {
          cartUpdatedObject[productId] = 0;
        }
      }

      if (product_type === "Combos") {
        totalCombosQuantity += quantity;
        totalCombosPrice += final_line_price;
      }

      if (product_type === "Footwear") {
        totalFootwearQty += quantity;
      }

      if (product_type != "Footwear" && product_type != "") {
        totalApparelPrice += final_line_price;
      }
    }
  );


  const cartTotalProductWithoutFreebie =
    user_cart?.item_count - totalFreeProduct - totalCombosQuantity;
  const cartTotalPriceWithoutFreebie =
    user_cart?.total_price - totalFreeProductPrice - totalCombosPrice;

  let totalQuantity = 0;
  let totalPrice = 0;

  let claimedGiftProducts = {};

  

  Object.entries(variantObject).forEach(([key, variant]) => {
    if (variant?.replace_variant) {

      const replaceId = variant.replace_variant;

      // Find the quantity & price of the current cart item being replaced
      const matchedItems = user_cart?.items.filter(
        (item) => item.id.toString() === replaceId
      );


      const itemWithSpecificPrice = matchedItems?.find(
        (item) => Number(item.final_price) === Number(variant?.final_price)
      );


      if (itemWithSpecificPrice) {
        const oldQty = itemWithSpecificPrice.quantity;
        const oldPrice = itemWithSpecificPrice.final_line_price;

        // Reduce totals to offset the old variant being removed
        totalQuantity -= oldQty;
        totalPrice -= oldPrice;

        // Mark the old variant for removal
        cartUpdatedObject[replaceId] = 0;
      }

    }

    if (variant?.type !== "Combos" && variant?.claimed_gift !== "true") {
      totalQuantity += variant?.quantity;
      totalPrice += variant?.price * variant?.quantity;
    }

    if (variant?.claimed_gift === "true") {
      
      localStorageClaimGift[key] = event === "CLAIM_ADD" ? variant?.quantity : 0;
    }
  });

  
  

  if (Object.entries(localStorageClaimGift)?.length > 0) {
    const existingClaimGift = Object.values(localStorageClaimGift).filter(value => value > 0).length;
    if(existingClaimGift <= claimGiftLimit){
      localStorage.setItem(
        "claimedGiftProducts",
        JSON.stringify(localStorageClaimGift)
    );
    }
    else{
      showMessage("You can only claim up to " + claimGiftLimit + " gifts", true);
      isProcessing = false;
      stopLoader();
      return;
    }

  }

  const adjustedCartQuantity =
    cartTotalProductWithoutFreebie +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalQuantity
      : event === "REMOVE" || event == "REMOVE PROTECTOR"
      ? -totalQuantity
      : 0);

  const adjustedCartPrice =
    cartTotalPriceWithoutFreebie +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalPrice
      : event === "REMOVE" || event == "REMOVE PROTECTOR"
      ? -totalPrice
      : 0);

  const discountPriceCheck =
    user_cart?.total_price +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalPrice
      : event === "REMOVE" || event == "REMOVE PROTECTOR"
      ? -totalPrice
      : 0);

  let deltaFootwearQty = 0;

Object.entries(variantObject).forEach(([key, variant]) => {
  if (variant?.type === "Footwear") {
    if (event === "ADD") {
      deltaFootwearQty += variant.quantity;
    } else if (event === "MULTI_ADD") {
      deltaFootwearQty += 1;
    } else if (event === "REMOVE" || event == "REMOVE PROTECTOR") {
      deltaFootwearQty -= variant.quantity;
    }
  }
});
const adjustFootwearQty = totalFootwearQty + deltaFootwearQty;

let deltaApparelPrice = 0;
Object.entries(variantObject).forEach(([key, variant]) => {
  if (variant?.type != "Footwear" && variant?.type != "") {
    if (event === "ADD") {
      deltaApparelPrice += variant.price * variant.quantity;
    } else if (event === "REMOVE" || event == "REMOVE PROTECTOR") {
      deltaApparelPrice -= variant.price * variant.quantity;
    }
  }
});
var adjustApparelPrice = totalApparelPrice + deltaApparelPrice;

  // Find applicable rule
  const applicableRule = getApplicableRule(
    filteredObjects,
    adjustedCartQuantity,
    adjustedCartPrice
  );

  if (applicableRule?.get_y?.length) {
    applicableRule.get_y.forEach((variant) => {
      cartUpdatedObject[variant.split("/").pop()] = 1;
    });
  }

  //Claim Gift Logic
  // Check if the gift is claimed
  
  
    const applicableRuleClaimGift = getApplicableRule(
      claimGift,
      adjustedCartQuantity,
      adjustedCartPrice
    );

    if (applicableRuleClaimGift) {
      if (applicableRuleClaimGift?.gift_products?.length) {
        if (localStorageClaimGift) {
          applicableRuleClaimGift.gift_products.forEach((variant) => {
            var variantId = variant.split("/").pop();
            if (localStorageClaimGift.hasOwnProperty(variantId)) {
              cartUpdatedObject[variantId] = localStorageClaimGift[variantId];
            }
          });
        }
      }
    } else {
      localStorage.removeItem("claimedGiftProducts");
    }
  

  // Update cart quantities based on event
  Object.entries(variantObject).forEach(([productId, { quantity }]) => {
    const currentQty = cartUpdatedObject[productId] || 0;
    const currentQuantiyAll = allProducts[productId] || 0;
    cartUpdatedObject[productId] =
      event === "ADD"
        ? currentQty + quantity
        : event === "MULTI_ADD"
        ? 1
        : event === "REMOVE" || event == "REMOVE PROTECTOR"
        ? Math.max(0, currentQty - quantity)
        : currentQty;

        allProducts[productId] =
        event === "ADD"
          ? currentQuantiyAll + quantity
          : event === "MULTI_ADD"
          ? 1
          : event === "REMOVE" || event == "REMOVE PROTECTOR"
          ? Math.max(0, currentQty - quantity)
          : currentQty;
  });

  // Apply freebie rules
  cartFreebie?.forEach(({ freebie, products }) => {
    if (freebie.length > 0) {
      products.forEach((productId) => {
        if (
          cartUpdatedObject[productId] &&
          cartUpdatedObject[productId] !== 0
        ) {
          cartUpdatedObject[freebie[0]] = 1;
        }
      });
    }
  });

  
  const footwearProtectIdInt = parseInt(footwearProtectId);

  // Check if this variant is already in the cart
  const isFootwearProtectInCart = user_cart?.items?.some(
    (item) => item.id === footwearProtectIdInt
  );
  if (user_cart?.items) {
    const cartItem = user_cart.items.find(item => item.variant_id == footwearProtectIdInt);
    quantity = cartItem ? cartItem.quantity : 0;
  }
  if (footwearProtectId) {
    if (event === "ADD"){
      const wrapper = document.querySelector("#protectorVariantSelect");

        [...wrapper?.options].forEach(opt => {
          if (opt.value !== "0" && opt.value != footwearProtectIdInt) {
            cartUpdatedObject[opt.value] = 0;
          }
        });
    }
  }
  if (footwearProtectId && isFootwearProtectInCart) {
    if (event === "REMOVE PROTECTOR") {
      cartUpdatedObject[footwearProtectId] = 0;
    }else{
      cartUpdatedObject[footwearProtectId] = adjustFootwearQty;
    }

    
    
  }


  // --- BOGO AUTO-ADD: start ---
try {
  const bogoRaw = document.body.getAttribute("bogooffers");
  if (bogoRaw) {
    const offers = JSON.parse(bogoRaw); // Directly get offers array (variant IDs ready)
    const autoAdded = [];

    // Helper: sum quantities for given variant IDs from allProducts
    const sumQtyFor = (variantIds = []) => {
      return variantIds.reduce((sum, vid) => {
        const s = Number(allProducts[String(vid)] || 0);
        return sum + s;
      }, 0);
    };

    offers.forEach((offer) => {
      if (!offer.auto_add) return;

      const triggerVariantIds = offer.trigger_products || [];
      const offerVariantIds = offer.offer_products || [];
      const triggerCountNeeded = Number(offer.trigger_count || 1);


      // Auto-add only when there's exactly one offer variant
      if (offerVariantIds.length !== 1) return;

      const offerVid = offerVariantIds[0];

      const triggerMatched = sumQtyFor(triggerVariantIds);
      const offerMatched = sumQtyFor(offerVariantIds);

      if (triggerMatched >= triggerCountNeeded && offerMatched === 0) {
        if (event === "REMOVE" || event === "REMOVE PROTECTOR") return;

        if ((cartUpdatedObject[String(offerVid)] || 0) === 0) {
          cartUpdatedObject[String(offerVid)] = 1; // add 1 of the offer variant
          autoAdded.push(offerVid);
        }
      }
    });

    if (autoAdded.length) {
      
    }
  }
} catch (err) {
  console.warn("BOGO auto-add error:", err);
}
// --- BOGO AUTO-ADD: end ---


  if(checkExceedLimit(allProducts, 500)){
    showExceedingMessage("You can only add up to 500 of the same item");
    updateQuantity(variantObject, null);
    stopLoader();
    isProcessing = false;
    return;
  }

  var adjustApparelPrice = adjustApparelPrice / 100;
  const trigger_limit_1 = 250;
  const trigger_limit_2 = 500;

  const apparel_wrapper = document.querySelector("#apparelProtectorVariantSelect");
  const curret_apparel_variant_id = apparel_wrapper?.value;
  const apparel_variant_id_v1 = apparel_wrapper?.getAttribute("data-variant-level-1-id");
  const apparel_variant_id_v2 = apparel_wrapper?.getAttribute("data-variant-level-2-id");
  const apparel_variant_id_v3 = apparel_wrapper?.getAttribute("data-variant-level-3-id");

  if (cartUpdatedObject[apparel_variant_id_v1] || cartUpdatedObject[apparel_variant_id_v2] || cartUpdatedObject[apparel_variant_id_v3]){
    if(adjustApparelPrice <= trigger_limit_1 && adjustApparelPrice > 0){
      if(curret_apparel_variant_id != apparel_variant_id_v1){
        if (cartUpdatedObject[apparel_variant_id_v2] != 0) {
          cartUpdatedObject[apparel_variant_id_v2] = 0; 
        }
        if (cartUpdatedObject[apparel_variant_id_v3] != 0) {
          cartUpdatedObject[apparel_variant_id_v3] = 0; 
        }
        cartUpdatedObject[apparel_variant_id_v1] = 1;
      }
    }else if(adjustApparelPrice > trigger_limit_1 && adjustApparelPrice <= trigger_limit_2){
      if(curret_apparel_variant_id != apparel_variant_id_v2){
        if (cartUpdatedObject[apparel_variant_id_v1] != 0) {
          cartUpdatedObject[apparel_variant_id_v1] = 0; 
        }
        if (cartUpdatedObject[apparel_variant_id_v3] != 0) {
          cartUpdatedObject[apparel_variant_id_v3] = 0; 
        }
        cartUpdatedObject[apparel_variant_id_v2] = 1;
      }
    }else if(adjustApparelPrice > trigger_limit_2){
      if(curret_apparel_variant_id != apparel_variant_id_v3){
        if (cartUpdatedObject[apparel_variant_id_v2] != 0) {
          cartUpdatedObject[apparel_variant_id_v2] = 0; 
        }
        if (cartUpdatedObject[apparel_variant_id_v1] != 0) {
          cartUpdatedObject[apparel_variant_id_v1] = 0; 
        }
        cartUpdatedObject[apparel_variant_id_v3] = 1;
      }
    }else if(adjustApparelPrice == 0){
      if (cartUpdatedObject[apparel_variant_id_v1] != 0) {
        cartUpdatedObject[apparel_variant_id_v1] = 0; 
      }
      if (cartUpdatedObject[apparel_variant_id_v2] != 0) {
        cartUpdatedObject[apparel_variant_id_v2] = 0; 
      }
      if (cartUpdatedObject[apparel_variant_id_v3] != 0) {
        cartUpdatedObject[apparel_variant_id_v3] = 0; 
      }
    }
  }

  const finalPayload = { updates: cartUpdatedObject };

  if (Object.keys(cartUpdatedObject).length > 0) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        cache: "no-store",
        priority: "high",
        keepalive: true,
      },
      body: JSON.stringify(finalPayload),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`devx-cartx HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        user_cart = data;
        isProcessing = false;
        if (
          data?.total_price !== discountPriceCheck &&
          data?.total_price !== 0
        ) {
          cartx();
          updateQuantity(variantObject, event);
        } else {
          reload_cartx(); // Now safely called after update completes
          updateQuantity(variantObject, event);
          updateBubble(user_cart?.item_count);
          // currentDiscountCodes =  user_cart?.attributes?.appliedDiscount.split(',') || [];
          checkDiscountCode(user_cart);
        }
        if (event === "ADD" || event === "MULTI_ADD") {
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer?.classList.contains("drawer-open") == false) {
            // document.querySelector('.cartx-add-to-cart-popup')?.classList.remove('hide');
            // document.body.classList.remove("overflow-hidden");
            const quickViewWarpper = document.getElementById("quickViewWrapper");
            quickViewWarpper.classList.remove("show__modal");
            // hideCartOpenTost();
            const cartDrawer = document.querySelector("cart-drawer");
            const overlay = document.querySelector(".cartx-drawer-overlay");
            if (cartDrawer && overlay) {
              cartDrawer.classList.add("drawer-open");
              overlay.classList.add("open-overlay");
            } 
            document.body.classList.add("cartx-open");
          }
        }
        console.log('dkdkdkdkd function end time ------', new Date().toLocaleTimeString());
      })
      .catch((error) => {
        console.error("devx-cartx Error updating cart:", error);
        stopLoader();
        isProcessing = false;
      })
      .finally(() => {});
  } else {
    bindingEvent();
    stopLoader();
    checkDiscountCode(user_cart);
    isProcessing = false;
    // currentDiscountCodes =  user_cart?.attributes?.appliedDiscount.split(',') || [];
  }
}

function checkExceedLimit(object, limit) {
  return Object.values(object).some(value => value > limit);
}

function hideCartOpenTost() {
  setTimeout(function () {
    document.querySelectorAll('.cartx-add-to-cart-popup').forEach(function(el) {
      el.classList.add('hide');
    });
  }, 5000);
}

// Function to clean the cartFreebie data
function cleanData(cartFreebie) {
  return cartFreebie?.map((item) => ({
    freebie: item.freebie.map((id) =>
      id.replace("gid://shopify/ProductVariant/", "")
    ),
    products: item.products.map((id) =>
      id.replace("gid://shopify/ProductVariant/", "")
    ),
  }));
}

function getApplicableRule(
  filteredObjects,
  adjustedCartQuantity,
  adjustedCartPrice
) {
  if (!filteredObjects || !filteredObjects.length) return null;

  const applicableRules = filteredObjects.filter(
    ({ triggered_quantity, trigger_price }) => {
      if (triggered_quantity !== undefined) {
        return adjustedCartQuantity >= triggered_quantity;
      } else if (trigger_price !== undefined) {
        return adjustedCartPrice >= trigger_price * 100;
      }
      return false;
    }
  );

  const sortedRules = applicableRules.sort((a, b) => {
    const aVal =
      a.triggered_quantity !== undefined
        ? a.triggered_quantity
        : a.trigger_price !== undefined
        ? a.trigger_price * 100
        : 0;

    const bVal =
      b.triggered_quantity !== undefined
        ? b.triggered_quantity
        : b.trigger_price !== undefined
        ? b.trigger_price * 100
        : 0;

    return bVal - aVal; // descending
  });

  return sortedRules[0] || null;
}

function reload_cartx(cart_visible = false, event = null) {
  const sectionId = "cartx-drawer";

  const currentInner = document.querySelector(
    `#shopify-section-${sectionId} .cartx-drawer-inner`
  );

  const oldBottomCart = document.querySelector(
    `#shopify-section-${sectionId} #cartx-bottom-cart`
  );
  currentInner?.classList.add("is-loading");
  let cartScrollPosition = document.querySelector('.cartx-drawer-body-wrap').scrollTop;

  fetch(window.location.pathname + `?sections=${sectionId}`, {
    cache: "no-store",
    priority: "high",
    keepalive: true,
  })
    .then((res) => res.json())
    .then((data) => {
      const updated_cart_html = data[sectionId];

      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(updated_cart_html, "text/html");
      const newCartInner = htmlDoc.querySelector(".cartx-drawer-inner");
      const bottomCart = htmlDoc.getElementById("cartx-bottom-cart");

      if (newCartInner && currentInner) {
        currentInner.innerHTML = newCartInner.innerHTML;
        document.querySelector('.cartx-drawer-body-wrap').scrollTop = cartScrollPosition;
        if(showConfetti){
          cartConfetti();
        }
        showConfetti = false;

        const ai_base_upsell = newCartInner.getAttribute("ai-cart-upsell"); 
        if (ai_base_upsell && ai_base_upsell == "true") {
          if (user_cart?.item_count > 0) {
            updateAiUpsell(user_cart?.items);
          }
          bindingEvent();
        }else{
          bindingEvent();
          loadedEvents();
        }

        
        
        
      }
      if (oldBottomCart && bottomCart) {
        oldBottomCart.innerHTML = bottomCart.innerHTML;
        if (user_cart?.item_count > 0) {
          oldBottomCart.classList.add("show-slide");
        } else {
          oldBottomCart.classList.remove("show-slide");
        }
      }
    })
    .catch((error) => {
      console.error("Error reloading cart:", error);
    })
    .finally(() => {
      currentInner?.classList.remove("is-loading");
      stopLoader();
      loadedEvents();
    });
}

function updateQuantity(variantObject = {}, event) {
  if (!variantObject) return;

  Object.entries(variantObject).forEach(([productId, { quantity }]) => {
    const quantityElements = document.querySelectorAll(
      '.cartx-atc-qty[data-variant-id="' + productId + '"]'
    );

    const quantityElementsWrapper = document.querySelectorAll(
      '.cartx-product-button-wrap[data-variant-id="' + productId + '"]'
    );

    quantityElementsWrapper?.forEach((element) => {
      const el = element.querySelector(".cartx-atc-qty");

      if (el) {
        const addToCart = element.querySelector(".cartx-add-to-cart");
        const plusMinusWrapper = element.querySelector(".cartx-add-to-cart-qty-wrap");

        if (event) {
          if(event == 'CHANGE'){
            el.value = Number(quantity);
          }
          else{
            el.value =
            Number(el?.value) +
            (event === "ADD" || event == "MULTI_ADD" ? 1 : -1) * Number(quantity);
          }
        } 

        if (Number(el.value) > 0) {
          addToCart.style.display = "none";
          plusMinusWrapper.style.display = "flex";
        } else {
          addToCart.style.display = "flex";
          plusMinusWrapper.style.display = "none";
        }


      }
              // Always remove loading state, even if event is not found
              if (element.classList.contains("cartx-button-loadding")) {
                element.classList.remove("cartx-button-loadding");
              }
    });
  });
}


function updateBubble(cartCount) {
  const bubbleElements = document.querySelectorAll(".cart-count-bubble");

  const bubbleEle = document.getElementById("cart-icon-bubble");

  bubbleElements.forEach((bubble) => {
    bubbleCount(bubble, cartCount);
  });

  bubbleCount(bubbleEle, cartCount);
}

function bubbleCount(bubble, cartCount) {
  const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
  const hiddenCount = bubble.querySelector(".visually-hidden");

  if (visibleCount) visibleCount.textContent = cartCount;
  if (hiddenCount) hiddenCount.textContent = `${cartCount} items`;
}

function applyCode(codeInput = null) {
  const code = (
    codeInput || document.querySelector(".prv-coupon-input")
  ).value.trim();

  applyDiscount(user_cart?.token, code);
}

// Validate discount code format
function validateDiscountCode(code) {
  // Basic validation - adjust pattern as needed
  return code.replace(/[^\w\-]/g, "");
}

async function applyDiscount(cartId, discountCode) {
  if (!discountCode) {
    showMessage("Please enter a discount code.", true);
    return;
  }

  if (typeof user_cart === "undefined" || user_cart?.item_count === 0) {
    showMessage("Your cart is empty. Add items before applying a code.", true);
    return;
  }

  const sanitizedCode = validateDiscountCode(discountCode);
  if (!sanitizedCode) {
    showMessage("Invalid discount code format.", true);
    return;
  }

  const upperCaseCode = sanitizedCode.toUpperCase();

  if (currentDiscountCodes.includes(upperCaseCode)) {
    showMessage(`Discount code "${sanitizedCode}" is already applied.`, true);
    return;
  }
  startLoader();
  const updatedDiscountCodes = [...currentDiscountCodes, upperCaseCode];

  const query = `
    mutation {
      cartDiscountCodesUpdate(cartId: "gid://shopify/Cart/${cartId}", discountCodes: ${JSON.stringify(
    updatedDiscountCodes
  )}) {
        cart {
          id
          discountCodes {
            code
            applicable
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const response = await fetch(shopifyStorefrontApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": shopifyStorefrontToken,
      },
      body: JSON.stringify({ query }),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      stopLoader();
      throw new Error(`API responded with status ${response.status}`);
    }

    const data = await response.json();

    if (data.errors) {
      const firstError = data.errors[0];
      const message =
        firstError.extensions?.code === "UNAUTHORIZED"
          ? "Session expired. Please refresh the page and try again."
          : `Error: ${firstError.message}`;
      showMessage(message, true);
      stopLoader();

      return;
    }

    const discountInfo = data.data?.cartDiscountCodesUpdate;

    if (discountInfo?.userErrors?.length) {
      showMessage(discountInfo.userErrors[0].message, true);
      stopLoader();
    } else {
      const allDiscounts = discountInfo.cart.discountCodes;
      const applicableDiscounts = allDiscounts.filter((d) => d.applicable);
      const newCodeStatus = allDiscounts.find(
        (d) => d.code.toUpperCase() === sanitizedCode.toUpperCase()
      );

      if (newCodeStatus?.applicable) {
        fetchCart();
        showConfetti = true;
      } else {
        showMessage(
          `Discount code "${sanitizedCode}" is not applicable to your cart.`,
          true
        );
        stopLoader();
      }
    }
  } catch (error) {
    stopLoader();
    console.error("Error applying discount:", error);
    const message =
      error.name === "AbortError"
        ? "Request timed out. Please try again."
        : error.message.includes("NetworkError")
        ? "Network error. Please check your connection and try again."
        : "Error applying discount. Please try again later.";
    showMessage(message, true);
  }
}

async function removeDiscount(cartId, discountCode) {
  startLoader();

  let removeDiscount = [
    ...currentDiscountCodes?.filter(
      (item) => item.toUpperCase() !== discountCode.toUpperCase()
    ),
  ];

  const query = `
    mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
      cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
        cart {
          id
          discountCodes {
            code
            applicable
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const variables = {
    cartId: `gid://shopify/Cart/${cartId}`,
    discountCodes: removeDiscount,
  };

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const response = await fetch(shopifyStorefrontApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": shopifyStorefrontToken,
      },
      body: JSON.stringify({ query, variables }),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      stopLoader();
      throw new Error(`API responded with status ${response.status}`);
    }

    const data = await response.json();

    if (data.errors) {
      const firstError = data.errors[0];
      const message =
        firstError.extensions?.code === "UNAUTHORIZED"
          ? "Session expired. Please refresh the page and try again."
          : `Error: ${firstError.message}`;
      showMessage(message, true);
      stopLoader();

      return;
    }

    const discountInfo = data.data?.cartDiscountCodesUpdate;

    if (discountInfo?.userErrors?.length) {
      showMessage(discountInfo.userErrors[0].message, true);
      stopLoader();
    } else {
      const allDiscounts = discountInfo.cart.discountCodes;
      const applicableDiscounts = allDiscounts.filter((d) => d.applicable);

      currentDiscountCodes = applicableDiscounts.map((d) =>
        d.code.toUpperCase()
      );

      cartx();
    }
  } catch (error) {
    stopLoader();
    console.error("Error applying discount:", error);
    const message =
      error.name === "AbortError"
        ? "Request timed out. Please try again."
        : error.message.includes("NetworkError")
        ? "Network error. Please check your connection and try again."
        : "Error applying discount. Please try again later.";
    showMessage(message, true);
  }
}

function checkDiscountCode(cart) {
  const uniqueDiscountCodes = new Set();
  cart?.items.forEach((item) => {
    item.line_level_discount_allocations
      .filter((item) => item.discount_application.type === "discount_code")
      .forEach((item) =>
        uniqueDiscountCodes.add(item.discount_application.title)
      );
  });
  cart.cart_level_discount_applications
    .filter((item) => item.discount_application?.type === "discount_code")
    .forEach((item) =>
      uniqueDiscountCodes.add(item.discount_application.title)
    );

  currentDiscountCodes = [...uniqueDiscountCodes].map((code) =>
    code.toUpperCase()
  );
  
}

function showMessage(message, isError = false) {
  const messageElement = document.querySelector(".cartx-apply-code__message"); // replace with actual selector
  if (!messageElement) return;

  const messageElementWrapper = document.querySelector(
    ".cartx-apply-code-wrapper"
  );
  if (!messageElementWrapper) return;

  messageElement.textContent = message;
  messageElementWrapper.classList.add(isError ? "red-message" : "green-message");
  messageElementWrapper.classList.add("show-message");
  // messageElement.style.color = isError ? "red" : "green";

  setTimeout(() => {
    messageElementWrapper.classList.remove(isError ? "red-message" : "green-message");
    messageElementWrapper.classList.remove("show-message");
    messageElement.textContent = "";
    // messageElement.style.color = "";
  }, 3000);
}

function showExceedingMessage(message) {
  const messageElement = document.querySelector(".cartx-apply-code__message"); // replace with actual selector
  if (!messageElement) return;

  const messageElementWrapper = document.querySelector(
    ".cartx-apply-code-wrapper"
  );
  if (!messageElementWrapper) return;

  messageElement.textContent = message;
  messageElementWrapper.classList.add('purple-message');
  messageElementWrapper.classList.add("show-message");
  // messageElement.style.color = isError ? "red" : "green";

  setTimeout(() => {
    messageElementWrapper.classList.remove('purple-message');
    messageElementWrapper.classList.remove("show-message");
    messageElement.textContent = "";
    // messageElement.style.color = "";
  }, 2000);
}


function updateAiUpsell(variants) {
  const myHeaders = new Headers();
  myHeaders.append(
    "Authorization",
    "Bearer mAziEa3cb99NgwElCerb17ck7K3krpup7KvW3MFm"
  );

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const productGIDs = encodeURIComponent(
    JSON.stringify(
      variants?.map((product) => `gid://shopify/Product/${product.product_id}`)
    )
  );

  const upsellWrap = document.querySelector(".cartx-ai-upsell");

  fetch(
    `https://gn30lesfub.execute-api.ap-south-1.amazonaws.com/prod/6bda31ea-88ec-4108-894d-180b5822cbe3/datasource/5f9d4f4c-ee9f-4e24-bfa8-1be25cfdb29e/upsell?ids=${productGIDs}`,
    requestOptions
  )
    .then((response) => response.json())
    .then((data) => {
      const container = document.getElementById("cartx-upsell-product-list");
      
      
      if (data && data?.products?.length > 0 && Array.isArray(data?.products)) {
        data.products.forEach((product, index) => {
          if (upsellWrap) upsellWrap.style.display = "block";


          

          const variant = product?.variants?.edges?.[0]?.node;
          const image = product?.variants?.edges?.[0]?.node?.image?.url || "";
          const title = product?.title || "Untitled";
          const productType = product?.productType || "";
          const productUrl =
            "/products/" + product?.handle || "javascript:void(0);";

            const variants = product?.variants?.edges || [];
            const selectedVariantId = product?.selectedVariant?.id?.replace("gid://shopify/ProductVariant/", "");
            let variantOptionsHTML = "";
            
            if (variants.length > 1) {
              variantOptionsHTML = `
                <div class="cartx-variant-selector-wrapper">
                  <select class="cartx-variant-dropdown-main cartx-variant-upsell">
                    ${variants
                      .map(({ node }) => {
                        const variantId = node.id.replace("gid://shopify/ProductVariant/", "");
                        const price = (node.price.amount)*100;
                        const title = node.title;
                        const quantity = node.inventoryQuantity || 1; // fallback if not available
                        const selectedAttr = variantId === selectedVariantId ? "selected" : "";
                        const image = node.image?.url || "";
            
                        return `
                          <option 
                            data-quantity="1" 
                            data-image="${image}"
                            data-price="${price}" 
                            data-product-type="${productType}"
                            value="${variantId}" 
                            ${selectedAttr}
                          >
                            ${title}
                          </option>`;
                      })
                      .join("")}
                  </select>
                </div>`;
            }
            
            

          const price = variant.price.amount ? variant.price.amount / 1 : "0";
          const compareAtPrice = variant.compareAtPrice?.amount
            ? variant.compareAtPrice.amount / 1
            : "";

          const upsellDiv = document.createElement("div");
          upsellDiv.className = "cartx-upsell-product-item";
          upsellDiv.setAttribute(
            "data_prod_id",
            variant.id.replace("gid://shopify/ProductVariant/", "")
          );

          upsellDiv.innerHTML = `
  <div class="cartx-upsell-item-media">
    <img class="cartx-upsell-item-img" width="74" height="74" src="${image}&width=174" alt="${title}">
  </div>
  <div class="cartx-upsell-item-info">
    <a href=${productUrl} class="cartx-upsell-item-title">${title}</a>
    <div class="cartx-upsell-item-price-wrap">
      <div class="cartx-upsell-item-price">
        <span class="current-price">₹ ${price}.00</span>
      </div>
      ${variantOptionsHTML}
    </div>

    ${!priceArray.includes(price) ? `
      <div
        class="cartx-product-button-wrap"
        data-variant-id="${variant.id.replace(
          "gid://shopify/ProductVariant/",
          ""
        )}"
        data-quantity="1"
        data-price="${variant.price.amount * 100}"
        data-product-type="${productType}"
      >
        <div class="cartx-add-to-cart">
          <span>Add to Cart</span>
        </div>
        <div class="cartx-atc-loading" style="display:none;">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <path fill="white" d="M9.9 0.2l-0.2 1c3 0.8 5.3 3.5 5.3 6.8 0 3.9-3.1 7-7 7s-7-3.1-7-7c0-3.3 2.3-6 5.3-6.8l-0.2-1c-3.5 0.9-6.1 4.1-6.1 7.8 0 4.4 3.6 8 8 8s8-3.6 8-8c0-3.7-2.6-6.9-6.1-7.8z"></path>
          </svg>
        </div>
      </div>
    ` : ''}
  </div>
`;

          container.appendChild(upsellDiv);
        });
      } else {
        console.warn("No upsell products found or unexpected data format.");
        if (upsellWrap) upsellWrap.style.display = "none";
      }
      
      loadedEvents();
    })
    .catch((error) => {
      console.error("Error fetching upsell products:", error);
      if (upsellWrap) upsellWrap.style.display = "none";
    });
}

// function triggerUpsellEvent() {
//   document.querySelectorAll(".cartx-upsell-add-to-cart").forEach((button) => {
//     button.addEventListener("click", (event) => {
//       event.preventDefault();
//       const variantId = button.getAttribute("data-variant-id");
//       if (!variantId) return;

//       const variantObject = {
//         [variantId]: {
//           quantity: parseInt(button.getAttribute("data-quantity")) || 0,
//           price: parseInt(button.getAttribute("data-price")) || 0,
//           type: button.getAttribute("data-product-type") || "",
//         },
//       };

//       cartx(variantObject, "ADD");
//     });
//   });
// }

function cartConfetti() {
  

  var animation = lottie.loadAnimation({
      container: document.getElementById('cartx-confetti'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: 'https://cdn.shopify.com/s/files/1/0633/2183/3679/files/Main_Scene.json?v=1746784652'
  });

  showMessage('Coupon Applied Successfully!', false);
  animation.goToAndStop(0, true);
  animation.play();

  animation.addEventListener('complete', function() {
      animation.destroy();
      document.getElementById('cartx-confetti').innerHTML = '';
  });
}